import {toast} from "react-toastify";

export const numberToFinanceFormat = (number = 0, withSpaces = false) => {
    if (typeof number !== 'number') {
        return number;
    }
    if (!number) {
        return 0
    }
    let num = number
    if (!Number.isInteger(number)) {
        num = number.toFixed(1);
    }
    if (withSpaces) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const phoneNumberFormat = (number) => {
    number = number.indexOf('+') !== -1 ? number : `+${number}`;
    return number;
}

export const validPhone = phoneNumber =>{
    return phoneNumber && phoneNumber.length == 12;
}

// Note: The 't' function needs to be passed from the calling component/hook
export const requestErrorDisplay = (e, t, defaultTextKey = "common.toast.genericError") => {
    const defaultText = t ? t(defaultTextKey) : "Произошла ошибка, попробуйте позже"; // Fallback if t is not provided

    if (e.errors) {
        for (const eKey in e.errors) {
            toast.error(e.errors[eKey][0])
        }
    }

    if(e.status==409) toast.error(t ? t('common.errors.phoneExistsDriver') : 'В базе уже есть водитель с таким номером телефона'); // Fallback if t is not provided
    else if (e.errorText) toast.error(e.errorText) // Assuming errorText might be pre-translated or a key itself
    else if (e.message) toast.error(e.message) // Assuming message might be pre-translated or a key itself
    else toast.error(defaultText)
}


let timerDebounce = null
export const onDebounce = (fn, timer = 400) => {
    clearTimeout(timerDebounce)
    timerDebounce = setTimeout(fn, timer)
}
